module.exports = __webpack_public_path__ + "img/sightseeing-tour@2x.e9fe4dd4.png";